"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _LoginControllerBase2 = require("../LoginControllerBase");

var _LoginControllerBase3 = _interopRequireDefault(_LoginControllerBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginCarsNowController = function (_LoginControllerBase) {
  (0, _inherits3.default)(LoginCarsNowController, _LoginControllerBase);

  function LoginCarsNowController($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums) {
    "ngInject";

    (0, _classCallCheck3.default)(this, LoginCarsNowController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginCarsNowController.__proto__ || (0, _getPrototypeOf2.default)(LoginCarsNowController)).call(this, $location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums));

    _this.initialize();
    return _this;
  }

  return LoginCarsNowController;
}(_LoginControllerBase3.default);

exports.default = LoginCarsNowController;


// WEBPACK FOOTER //
// ./client/app/components/login/loginCarsNow/loginCarsNow.controller.js